import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {ToolComponent} from './tool/tool.component';
import {EditorComponent} from './tool/editor/editor.component';
import {PreviewComponent} from './tool/preview/preview.component';

const routes: Routes = [
  {
    path: '',
    component: ToolComponent,
    children: [
      {
        path: '',
        component: EditorComponent
      },
      {
        path: 'preview',
        component: PreviewComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
